const equipmentSlider = () => {

    const cards = document.querySelectorAll('.equipment-card');
    const prevBtn = document.querySelector('.equipment-prev');
    const nextBtn = document.querySelector('.equipment-next');

    if (!cards.length) return;

    let current = 0;
    let autoplay = null;

    const isMobile = () => window.innerWidth <= 810;

    const showSlide = (index) => {

        cards.forEach(card => {
            card.classList.remove('active');
        });

        cards[index].classList.add('active');
    };

    const nextSlide = () => {

        current++;

        if (current >= cards.length) {
            current = 0;
        }

        showSlide(current);
    };

    const prevSlide = () => {

        current--;

        if (current < 0) {
            current = cards.length - 1;
        }

        showSlide(current);
    };

    const stopAutoplay = () => {

        if (autoplay) {
            clearInterval(autoplay);
        }
    };

    const startAutoplay = () => {

        stopAutoplay();

        if (!isMobile()) return;

        autoplay = setInterval(() => {
            nextSlide();
        }, 2000);
    };

    const updateLayout = () => {

        if (isMobile()) {

            showSlide(current);

            startAutoplay();

        } else {

            stopAutoplay();

            cards.forEach(card => {
                card.classList.remove('active');
            });
        }
    };

    if (prevBtn) {

        prevBtn.addEventListener('click', () => {

            if (!isMobile()) return;

            prevSlide();

            startAutoplay();
        });
    }

    if (nextBtn) {

        nextBtn.addEventListener('click', () => {

            if (!isMobile()) return;

            nextSlide();

            startAutoplay();
        });
    }

    window.addEventListener('resize', updateLayout);

    updateLayout();
};

document.addEventListener('DOMContentLoaded', equipmentSlider);